<script lang="ts">
  import Icon from "../icons/Icon.svelte";

  export let isMobile: boolean;
  export let isLoading: boolean = false;
</script>

<button class:mobile={isMobile} class:loading={isLoading}>
  <div class="btn-icon">
    <Icon icon="waitlist-send" width="28px" height="26px" />
  </div>

  <div class="btn-loading">
    <Icon icon="loading" size="25px" />
  </div>
</button>

<style lang="postcss">
  button {
    @apply relative flex flex-row items-center justify-center rounded text-white;
    background-color: rgba(255, 255, 255, 0.3);
    border: 0px;
    width: 48px;
    height: 48px;
    color: white;
  }

  button.mobile {
    @apply px-3 py-2;
  }

  button:not(.loading):hover {
    /* background-color: rgba(255, 255, 255, 0.5);
    box-shadow: 0px 2px 6px rgba(8, 185, 255, 0.2); */
    background-color: white;
    color: #5F89FF;
  }

  .loading .btn-icon {
    opacity: 0;
  }

  .btn-loading {
    @apply absolute left-0 right-0 top-0 bottom-0 flex flex-row justify-center items-center rounded;
    opacity: 0;
    background-color: white;
    color: #5F89FF;
  }

  button.loading .btn-loading {
    opacity: 1;
  }
</style>
